(function () {
  const list = document.querySelector('[data-ai-agent-list]');
  const btn = document.querySelector('[data-ai-agent-load-more]');

  if (!list || !btn) return;

  const apiBase = '/pipefy-core/api/v1/ai-agents/cards';
  let paged = parseInt(list.dataset.paged, 10) || 1;
  const maxPages = parseInt(list.dataset.maxPages, 10) || 1;

  btn.addEventListener('click', async () => {
    if (paged >= maxPages) {
      btn.remove();
      return;
    }

    const originalLabel = btn.textContent.trim();
    const loadingLabel = btn.dataset.loadingLabel || '...';
    const errorLabel = btn.dataset.errorLabel || 'Something went wrong. Please try again.';

    const prevError = btn.parentElement.querySelector('.ai-agent-load-more-error');
    if (prevError) prevError.remove();

    btn.disabled = true;
    btn.textContent = loadingLabel;

    const params = new URLSearchParams({
      department: list.dataset.department || '',
      industry: list.dataset.industry || '',
      search: list.dataset.search || '',
      lang: list.dataset.lang || '',
      paged: paged + 1,
      per_page: 18,
    });

    try {
      const res = await fetch(`${apiBase}?${params}`);

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();

      if (data.html) {
        list.insertAdjacentHTML('beforeend', data.html);
        paged++;
      }

      if (!data.has_more) {
        btn.remove();
      } else {
        btn.textContent = originalLabel;
        btn.disabled = false;
      }
    } catch (e) {
      console.error('AI Agents load more failed', e);
      btn.textContent = originalLabel;
      btn.disabled = false;

      const errorMsg = document.createElement('p');
      errorMsg.className = 'ai-agent-load-more-error';
      errorMsg.textContent = errorLabel;
      btn.parentElement.appendChild(errorMsg);
    }
  });
})();
